import React, { FunctionComponent } from 'react'

import { DisplaySize, TextType } from '../../styles/typeStyles'
import { BaseText, BaseTextProps } from '../baseText/BaseText'

// Map display sizes to header levels for web accessibility (h1, h2, etc)
const defaultLevels: Partial<Record<DisplaySize, string>> = {
  [DisplaySize.LARGE]: '1',
  [DisplaySize.MEDIUM]: '1',
  [DisplaySize.SMALL]: '2',
  [DisplaySize.EYEBROW]: '5',
}

export const Display: FunctionComponent<DisplayProps> = (props) => {
  const { size, level, style } = props
  return (
    <BaseText
      {...props}
      type={TextType.DISPLAY}
      level={level === undefined ? defaultLevels[size] : level}
      style={style}
    />
  )
}
export const Size = DisplaySize

export interface DisplayProps extends Omit<BaseTextProps, 'size' | 'type'> {
  size: DisplaySize
}
